import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  ReactTurntableSection,
  TurntableCanvas,
  TurntableButton,
  ButtonBg,
  VerticalLine,
  DraggableDot,
} from './ReactTurntable.style'
import { isMobile, isMobileOnly } from 'react-device-detect'
import seedrandom from 'seedrandom'
import withLocation from '../HOC/withLocation'
import {
  PickerWheelTurntable,
  YNWTurntable,
  RNGTurntable,
  RLGTurntable,
  RIGTurntable,
  RCGTurntable,
  RDGTurntable,
  ICPTurntable,
  RCWTurntable,
} from './TurntableText'
import {
  setStartRotate,
  setWheelImages,
  increaseSpinQuantity,
  setHasSpinOnce,
} from '../../redux/turntable/actions'
import { setResultModalAppear } from '../../redux/modal/actions'
import { setBoardIndex, setResultsArray } from '../../redux/rng/actions'
import { updateColorWheelState } from '../../redux/rcw/actions'
import ImageUtil from '../../utils/imageUtil'
import { imagePlaceholder } from '../ReactRIG/imagePlaceholder'
import * as Audio from './TurntableSounds'
import { replaceCDN } from '../../utils'
import TipDrop from '../Button/TipDrop'
// import { fontSizes } from './TurntableFontSize'

//https://spicyyoghurt.com/tools/easing-functions

function accelerateCubic(t, b, c, d) {
  // return c * (t /= d) * t * t * t + b
  return c * (t /= d) * t * t + b
  // return c * (t /= d) * t + b
  // return (c * t) / d + b
}

const mapState = (state, ownProps) => {
  const pathname = ownProps.urlLocation.pathname

  // const music = state.settings.music
  let turntableText = ''
  let isRIG = false
  let isPW = false
  let isRCW = false
  let weightOn = ownProps.weightOn
  if (pathname === '/') {
    // mute = state.main.mute
    turntableText = PickerWheelTurntable
    weightOn = state.main.weightOn
    isPW = true
  } else if (pathname === '/tools/yes-or-no-wheel/') {
    // mute = state.ynw.mute
    turntableText = YNWTurntable
  } else if (pathname === '/tools/random-number-generator/') {
    // mute = state.rng.mute
    turntableText = RNGTurntable
  } else if (pathname === '/tools/random-letter-generator/') {
    // mute = state.rng.mute
    turntableText = RLGTurntable
  } else if (pathname === '/tools/random-image-generator/') {
    // mute = state.rng.mute
    turntableText = RIGTurntable
    isRIG = true
  } else if (pathname === '/tools/random-country-generator/') {
    // mute = state.rng.mute
    turntableText = RCGTurntable
  } else if (pathname === '/tools/random-date-generator/') {
    // mute = state.rng.mute
    turntableText = RDGTurntable
  } else if (pathname === '/tools/instagram-comment-picker/') {
    // mute = state.rng.mute
    turntableText = ICPTurntable
  } else if (pathname === '/tools/random-color-generator/') {
    turntableText = RCWTurntable
    isRCW = true
  }

  if (ownProps.isEmb) {
    return {
      ...ownProps,
      mysterySpin: false,
      angle: state.turntable.angle,
      turntableText,
      isRIG,
      isRNG: false,
      isPW,
      isRCW,
      weightOn,
      isEditing: false,
      hasSpinOnce: true, // set true to prevent tooltip
      initialSpinning: false, // set false to prevent initial spinning
      resultModalAppear: false,
      buttonAnimation: true,
      isBlankWheel: false,
    }
  }

  return {
    music: ownProps.music || state.settings.music,
    turntableText,
    isRIG,
    weightOn, //for split unevenly
    angle: state.turntable.angle,
    wheelImages: state.turntable.wheelImages,
    speed: state.settings.spinBehavior.speed,
    duration: state.settings.spinBehavior.duration,
    wheelColors: !isRCW
      ? state.settings.wheelColors.colors
      : ownProps.wheelColors,
    // wheelColorsTheme: state.settings.wheelColors.arrayKey,
    manualStop: state.settings.spinBehavior.manualStop,
    mysterySpin: !ownProps.isBlog && state.settings.spinBehavior.mysterySpin,
    spinButton: state.settings.spinButton,
    isRNG: pathname.includes('random-number-generator'),
    rng: {
      resultsArray: state.rng.resultsArray,
      boardIndex: state.rng.boardIndex,
      typeOption: state.rng.typeOption,
      autoSpinMerge: state.rng.autoSpinMerge,
      digitRanges: state.rng.digitRanges,
    },
    isPW,
    initialSpinning: state.settings.spinBehavior.initialSpinning,
    isEditing: state.turntable.isEditing,
    hasSpinOnce: state.turntable.hasSpinOnce,
    resultModalAppear: state.modal.resultModalAppear,
    buttonAnimation: state.settings.spinBehavior.buttonAnimation,
    isBlankWheel: ownProps.isBlankWheel,
    isRCW,
    rcw: {
      pointer: state.rcw.colorWheel.pointer,
      pointerPosition: state.rcw.colorWheel.pointerPosition,
      inputMethod: state.rcw.inputMethod,
      brightness: state.rcw.paletteWheel.brightness,
    },
  }
}

const actions = {
  setStartRotate,
  setWheelImages,
  setBoardIndex,
  setResultsArray,
  increaseSpinQuantity,
  setHasSpinOnce,
  setResultModalAppear,
  updateColorWheelState,
}

class ReactTurntable extends PureComponent {
  state = {
    isRotate: false,
    startRotate: 0,
    finishRender: false,
    alwaysSpinning: false,
    pieColor: '#FFF',
    buttonDown: false,
    dotPosition: 0, // color wheel - position of the dot in the line
    distanceFactor: 0, // color wheel - determines the color brightness on the color wheel (lower values make the color closer to white)
    spinningPointer: 'Random', // color wheel - the spinning pointer either Manual or Random
    startMoveDot: 0,
  }
  constructor(props) {
    super(props)
    this.rotatingCanvas = null
    this.rotatingCanvasCtx = null
    this.animateId = null
  }
  static defaultProps = {
    width: 600,
    height: 600,
    speed: 5, //旋转速度
    duration: 10, //旋转时间
    prizes: [],
    tempPrizes: ['YES', 'NO', 'YES', 'NO', 'YES', 'NO', 'YES', 'NO'],
    clickText: 'SPIN',
    wheelColors: ['#2b580c', '#f7b71d', '#afa939', '#fdef96'],
    fontStyle: {
      color: '#fff',
      size: 38,
      fontWeight: '400',
      fontVertical: false,
      fontFamily: `-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui,
      helvetica neue, helvetica, Ubuntu, roboto, noto, arial, sans-serif`,
    },
    onStart: () => true,
    hiddenButton: false,
    music: null,
    // mute: false,
  }
  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    prizes: PropTypes.array.isRequired,
    wheelColors: PropTypes.array.isRequired,
    tempPrizes: PropTypes.array.isRequired,
    clickText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    speed: PropTypes.number,
    duration: PropTypes.number,
    onComplete: PropTypes.func,
    onStart: PropTypes.func,
    fontVertical: PropTypes.bool,
    fontStyle: PropTypes.object,
    hiddenButton: PropTypes.bool,
    // mute: PropTypes.bool,
    music: PropTypes.object,
  }

  // start of rcw color wheel functions
  drawPickerWheelDot = () => {
    const dotPosition = this.calculateDotPositionFromStartMoveDot()
    const distanceFactor =
      this.calculateDistanceFactorFromDotPosition(dotPosition)
    this.setState({
      dotPosition: dotPosition,
      distanceFactor: distanceFactor,
    })
  }

  getDotParameters = () => {
    const dotSize = 15
    const dotRadius = dotSize / 2
    const rect = this.rotatingCanvas.getBoundingClientRect()
    const lineHeight = (rect.height - 20) * 0.5 - dotSize // Line height, adjusted by dot radius

    // Define the top and bottom positions
    const topPosition = -dotRadius + 10
    const bottomPosition = lineHeight + dotRadius + 10

    return { topPosition, bottomPosition, rectTop: rect.top }
  }

  calculateDotPositionFromStartMoveDot = () => {
    const { topPosition, bottomPosition } = this.getDotParameters()

    // Calculate dotPosition based on startMoveDot
    if (this.startMoveDot <= 50) {
      // Phase 1: Top to Bottom
      const normalizedValue = this.startMoveDot / 50 // Normalize to 0-1
      return topPosition + (bottomPosition - topPosition) * normalizedValue
    } else {
      // Phase 2: Bottom to Top
      const normalizedValue = (this.startMoveDot - 50) / 50 // Normalize to 0-1
      return bottomPosition - (bottomPosition - topPosition) * normalizedValue
    }
  }

  calculateStartMoveDotFromDistanceFactor = distanceFactor => {
    const validFactor = Math.max(0, Math.min(1, distanceFactor))
    const startMoveDot = (1 - validFactor) * 50
    return startMoveDot
  }

  calculateDotPositionFromDistanceFactor = distanceFactor => {
    const { topPosition, bottomPosition } = this.getDotParameters()
    const range = bottomPosition - topPosition

    const validFactor = Math.max(0, Math.min(1, distanceFactor)) // Ensure distanceFactor is within [0, 1]
    const dotPosition = bottomPosition - validFactor * range

    return dotPosition.toFixed(2)
  }

  calculateDistanceFactorFromDotPosition = dotPosition => {
    const { topPosition, bottomPosition } = this.getDotParameters()
    const range = bottomPosition - topPosition

    // Measure of how close dotPosition is to the lower boundary
    let distanceFactor = (bottomPosition - dotPosition) / range
    distanceFactor = Math.max(
      0,
      Math.min(1, parseFloat(distanceFactor.toFixed(2))),
    )

    return distanceFactor
  }

  handleMouseDown = e => {
    const { topPosition, bottomPosition, rectTop } = this.getDotParameters()

    const handleMouseMove = event => {
      if (!this.state.isRotate) {
        let clientY
        if (event.type === 'mousemove') {
          clientY = event.clientY
        } else if (event.type === 'touchmove') {
          clientY = event.touches[0].clientY
        }

        const newY = clientY - rectTop // Y position of the mouse relative to the canvas

        if (newY >= topPosition && newY <= bottomPosition) {
          const distanceFactor =
            this.calculateDistanceFactorFromDotPosition(newY)
          this.setState({ distanceFactor: distanceFactor, dotPosition: newY })
          this.props.updateColorWheelState('pointerPosition', distanceFactor)
        }
      }
    }

    const handleMouseUp = () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
      window.removeEventListener('touchmove', handleMouseMove)
      window.removeEventListener('touchend', handleMouseUp)
    }

    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)
    window.addEventListener('touchmove', handleMouseMove)
    window.addEventListener('touchend', handleMouseUp)
  }

  interpolateColor = (rgbColor, distanceFactor, colorBrightness) => {
    const parseRGB = rgbString => {
      const match = rgbString.match(/RGB\((\d+),(\d+),(\d+)\)/)
      if (match) {
        return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3])]
      }
      return [0, 0, 0]
    }

    const rgbToHex = (R, G, B) => {
      R = Math.max(0, Math.min(255, R))
      G = Math.max(0, Math.min(255, G))
      B = Math.max(0, Math.min(255, B))

      const hexR = R.toString(16).padStart(2, '0')
      const hexG = G.toString(16).padStart(2, '0')
      const hexB = B.toString(16).padStart(2, '0')

      return `#${hexR}${hexG}${hexB}`.toUpperCase()
    }

    const rgbToHsv = (R, G, B) => {
      R /= 255
      G /= 255
      B /= 255

      const max = Math.max(R, G, B)
      const min = Math.min(R, G, B)
      const delta = max - min

      let H = 0
      if (delta > 0) {
        if (max === R) H = ((G - B) / delta) % 6
        else if (max === G) H = (B - R) / delta + 2
        else H = (R - G) / delta + 4
      }
      H = Math.round(H * 60)
      if (H < 0) H += 360

      const S = max === 0 ? 0 : delta / max
      const V = max

      return [H, S, V]
    }

    const hsvToRgb = (H, S, V) => {
      const C = V * S
      const X = C * (1 - Math.abs(((H / 60) % 2) - 1))
      const m = V - C

      let [R, G, B] = [0, 0, 0]
      if (H >= 0 && H < 60) [R, G, B] = [C, X, 0]
      else if (H >= 60 && H < 120) [R, G, B] = [X, C, 0]
      else if (H >= 120 && H < 180) [R, G, B] = [0, C, X]
      else if (H >= 180 && H < 240) [R, G, B] = [0, X, C]
      else if (H >= 240 && H < 300) [R, G, B] = [X, 0, C]
      else if (H >= 300 && H < 360) [R, G, B] = [C, 0, X]

      R = Math.round((R + m) * 255)
      G = Math.round((G + m) * 255)
      B = Math.round((B + m) * 255)

      return [R, G, B]
    }

    let [R, G, B] = parseRGB(rgbColor)

    // Interpolate each color component based on the distance factor (toward white)
    R = Math.round(255 - (255 - R) * distanceFactor)
    G = Math.round(255 - (255 - G) * distanceFactor)
    B = Math.round(255 - (255 - B) * distanceFactor)

    // Convert the interpolated color to HSV
    let [H, S, V] = rgbToHsv(R, G, B)

    // Adjust brightness (V) value based on colorBrightness (0-100)
    V = colorBrightness / 100

    // Convert back to RGB after adjusting V
    ;[R, G, B] = hsvToRgb(H, S, V)

    const updatedColorObject = {
      hex: rgbToHex(R, G, B),
      rgb: `RGB(${R},${G},${B})`,
      name: '',
    }

    return updatedColorObject
  }
  // end of rcw color wheel functions

  render() {
    const {
      clickText,
      style,
      // className,
      width,
      height,
      hiddenButton,
      manualStop,
      hasSpinOnce,
      resultModalAppear,
      buttonAnimation,
    } = this.props
    const {
      finishRender,
      isRotate,
      pieColor,
      buttonDown,
      alwaysSpinning,
      dotPosition,
      distanceFactor,
    } = this.state
    const styles = { ...style, width, height }
    return (
      <ReactTurntableSection id="PickerWheelCanvas" style={styles}>
        <TurntableCanvas ref={node => (this.rotatingCanvas = node)}>
          {this.props.turntableText}
        </TurntableCanvas>
        {!hiddenButton &&
          finishRender &&
          (Object.is(typeof clickText, 'string') ? (
            // !this.props.isRIG ? (
            <>
              <ButtonBg
                opacity={
                  this.props.isRCW &&
                  this.props.rcw.inputMethod === 'ColorWheel'
                    ? 0
                    : 1
                }
                buttonAnimation={buttonAnimation}
                isRunning={isRotate || resultModalAppear}
                pieColor={pieColor}
                buttonDown={buttonDown}
              />
              <TipDrop
                content="or press Ctrl+Enter"
                position="bottom"
                disabled={hasSpinOnce}
              >
                <TurntableButton
                  opacity={
                    this.props.isRCW &&
                    this.props.rcw.inputMethod === 'ColorWheel'
                      ? 0.4
                      : 1
                  }
                  // id="SpinButton"
                  // tabIndex="-1"
                  //
                  spinButtonSetting={this.props.spinButton}
                  onMouseDown={e => {
                    // e.preventDefault() // cannot use e.preventDefault(), because it will cause the div cant focus, android mobile phone has chance will pop up keyboard
                    // document.getElementById('SpinButton').focus()
                    this.setState({ buttonDown: true })
                  }}
                  onMouseLeave={e => {
                    e.preventDefault()
                    this.setState({ buttonDown: false })
                  }}
                  onMouseUp={e => {
                    e.preventDefault()
                    this.setState({ buttonDown: false })
                  }}
                  buttonDown={buttonDown}
                  onClick={
                    !isRotate || !manualStop || !alwaysSpinning
                      ? this.onStartRotate
                      : this.stopRotate
                  }
                  spinButtonText={
                    !isRotate || !manualStop || !alwaysSpinning
                      ? clickText
                      : 'STOP'
                  }
                ></TurntableButton>
              </TipDrop>
              {this.props.isRCW &&
                this.props.rcw.inputMethod === 'ColorWheel' && (
                  <>
                    <VerticalLine
                      disableTouchAction={
                        this.props.isRCW &&
                        this.props.rcw.inputMethod === 'ColorWheel'
                      }
                    >
                      <TipDrop
                        content={`${Math.round(distanceFactor * 100)}%`}
                        position="bottom"
                      >
                        <DraggableDot
                          style={{ top: `${dotPosition}px` }}
                          onMouseDown={this.handleMouseDown}
                          onTouchStart={this.handleMouseDown}
                        />
                      </TipDrop>
                    </VerticalLine>
                  </>
                )}
            </>
          ) : (
            <div
              onClick={
                !isRotate || !manualStop ? this.onStartRotate : this.stopRotate
              }
            >
              {!isRotate || !manualStop ? clickText : 'STOP'}
            </div>
          ))}
      </ReactTurntableSection>
    )
  }
  noticePrize = () => {
    const prizeIndex = this.getSelectedPrizeIndex()
    let prize = this.prizes[prizeIndex]
    if (this.props.isRCW && this.props.rcw.inputMethod === 'ColorWheel') {
      prize = this.interpolateColor(
        prize,
        this.state.distanceFactor,
        this.props.rcw.brightness,
      )
    }

    this.props.setStartRotate(this.startRotate)
    if (!this.props.hasSpinOnce) {
      this.props.setHasSpinOnce(true)
    }
    // setTimeout(() => {
    //   this.setState({ pieColor: '#FFF' })
    // }, 1000)
    if (this.props.isPW) {
      const inputImage =
        this.inputImages !== undefined ? this.inputImages[prizeIndex] : null
      this.props.onComplete &&
        this.props.onComplete({ name: prize, data: inputImage }, prizeIndex)
      this.props.setResultModalAppear(true)
      if (this.props.music.soundOn) {
        if (!Audio.isSpinningSoundRepeat) {
          Audio.pauseSound('spinning')
        }
        Audio.playSound('ending')
      }
    } else if (!this.props.isRNG) {
      this.props.onComplete && this.props.onComplete(prize, prizeIndex)
      this.props.setResultModalAppear(true)
      // if (this.props.music.soundOn && this.props.music.celebrating) {
      if (this.props.music.soundOn) {
        if (!Audio.isSpinningSoundRepeat) {
          Audio.pauseSound('spinning')
        }
        // if (!this.props.isEmb) {
        Audio.playSound('ending')
        // this.audio2.play()
        // } else {
        //   Audio.playSound('short')
        //   // this.shortAnnounceAudio.play()
        // }
      }
    } else {
      const {
        resultsArray,
        boardIndex,
        typeOption,
        autoSpinMerge,
        digitRanges,
      } = this.props.rng
      if (typeOption > 0) {
        const arrayTemp = resultsArray.slice()
        arrayTemp[boardIndex] = prize
        this.props.setResultsArray(arrayTemp)
        const newIndex = arrayTemp.indexOf(null)
        if (newIndex !== -1) {
          // still haven't fully disclosed

          this.props.setBoardIndex(newIndex)
          this.prizes = Array.from(
            { length: digitRanges[newIndex][1] - digitRanges[newIndex][0] + 1 },
            (_, i) => i + digitRanges[newIndex][0],
          )
          this.awardRotate = (Math.PI * 2) / this.prizes.length
          this.wheelCanvas = null
          this.drawPickerWheel()
          // if (this.props.music.soundOn && this.props.music.celebrating) {
          if (this.props.music.soundOn) {
            if (!autoSpinMerge && !Audio.isSpinningSoundRepeat) {
              Audio.pauseSound('spinning') //for manual stop
            }
            Audio.playSound('short')
            // this.shortAnnounceAudio.play()
          }
          if (autoSpinMerge) {
            setTimeout(() => {
              this.onStartRotate(false)
            }, 200)
          }
        } else {
          const mergedResults = arrayTemp.slice().reverse().join('')
          this.props.onComplete && this.props.onComplete(mergedResults)
          this.props.setResultModalAppear(true)
          // if (this.props.music.soundOn && this.props.music.celebrating) {
          if (this.props.music.soundOn) {
            if (!Audio.isSpinningSoundRepeat) {
              Audio.pauseSound('spinning')
            }
            Audio.playSound('ending')
            // this.audio2.play()
          }
        }
      } else {
        this.props.onComplete && this.props.onComplete(prize)
        this.props.setResultModalAppear(true)
        // if (this.props.music.soundOn && this.props.music.celebrating) {
        if (this.props.music.soundOn) {
          if (!Audio.isSpinningSoundRepeat) {
            Audio.pauseSound('spinning')
          }
          Audio.playSound('ending')
          // this.audio2.play()
        }
      }
    }
  }

  getCurrentPosition = () => {
    const startAngle = (this.startRotate * 180) / Math.PI
    const pointerAngle = 90
    const overAngle = (startAngle + pointerAngle) % 360
    const restAngle = 360 - overAngle
    let index
    if (this.props.weightOn === false) {
      const awardAngle = (this.awardRotate * 180) / Math.PI
      index = Math.floor(restAngle / awardAngle)
    } else {
      let tempAngle = restAngle
      for (let i = 0; i < this.awardRotate.length; i++) {
        const awardAngle = (this.awardRotate[i] * 180) / Math.PI
        tempAngle -= awardAngle
        if (tempAngle <= 0.0) {
          index = i
          break
        }
      }
    }
    return index
  }

  getSelectedPrizeIndex = () => {
    const startAngle = (this.startRotate * 180) / Math.PI
    const pointerAngle = 90
    const overAngle = (startAngle + pointerAngle) % 360
    const restAngle = 360 - overAngle
    let index
    if (this.props.weightOn === false) {
      const awardAngle = (this.awardRotate * 180) / Math.PI
      index = Math.floor(restAngle / awardAngle)
    } else {
      let tempAngle = restAngle
      for (let i = 0; i < this.awardRotate.length; i++) {
        const awardAngle = (this.awardRotate[i] * 180) / Math.PI
        tempAngle -= awardAngle
        if (tempAngle <= 0.0) {
          index = i
          break
        }
      }
    }
    return index
  }

  drawPickerWheel = async () => {
    if (!this.wheelCanvas) {
      const { width, height } = this.props
      this.wheelCanvas = ImageUtil.createTempImage(
        width * this.dpiRatio,
        height * this.dpiRatio,
      )
      const wheelCanvasCtx = this.wheelCanvas.getContext('2d')
      wheelCanvasCtx.scale(this.dpiRatio, this.dpiRatio)
      // const beforeDraw = Date.now()

      if (this.props.isRCW && this.props.rcw.inputMethod === 'ColorWheel') {
        await this.drawTurntableColorWheel(wheelCanvasCtx, width, height)
      } else {
        await this.drawTurntable(wheelCanvasCtx, width, height)
      }
      // const afterDraw = Date.now()
    }
    if (this.rotatingCanvasCtx !== undefined) {
      //initial render has 2 times, the second time render is undefined
      this.rotatingCanvasCtx.clearRect(
        0,
        0,
        this.rotatingCanvas.width,
        this.rotatingCanvas.height,
      )
      this.rotatingCanvasCtx.save()
      this.rotatingCanvasCtx.translate(this.centerX, this.centerY)
      this.rotatingCanvasCtx.rotate(this.startRotate)
      this.rotatingCanvasCtx.translate(-this.centerX, -this.centerY)
      this.rotatingCanvasCtx.drawImage(this.wheelCanvas, 0, 0)
      this.rotatingCanvasCtx.restore()
    }
  }

  drawTurntableColorWheel = async (ctx, width, height) => {
    if (ctx.canvas.width === 0 || ctx.canvas.height === 0) {
      return
    }

    // Clear and save the canvas context
    ctx.clearRect(0, 0, width, height)
    ctx.save()

    // Adjust radius by subtracting 10
    const adjustedRadius = width / 2 - 10

    // Create the conic gradient and fill the canvas
    const conicGradient = ctx.createConicGradient(0, width / 2, height / 2)
    conicGradient.addColorStop(0, 'red')
    conicGradient.addColorStop(1 / 6, 'yellow')
    conicGradient.addColorStop(2 / 6, 'lime')
    conicGradient.addColorStop(3 / 6, 'aqua')
    conicGradient.addColorStop(4 / 6, 'blue')
    conicGradient.addColorStop(5 / 6, 'magenta')
    conicGradient.addColorStop(1, 'red')

    ctx.fillStyle = conicGradient
    ctx.beginPath()
    ctx.arc(width / 2, height / 2, adjustedRadius, 0, 2 * Math.PI)
    ctx.fill()

    // Add the radial gradient on top for the fade-to-transparent effect
    const radialGradient = ctx.createRadialGradient(
      width / 2,
      height / 2,
      0,
      width / 2,
      height / 2,
      adjustedRadius,
    )
    radialGradient.addColorStop(0, 'rgba(255, 255, 255, 1)')
    radialGradient.addColorStop(1, 'rgba(255, 255, 255, 0)')

    ctx.fillStyle = radialGradient
    ctx.beginPath()
    ctx.arc(width / 2, height / 2, adjustedRadius, 0, 2 * Math.PI)
    ctx.fill()

    // Add a new layer to adjust the brightness (0-100)
    const alpha = 1 - this.props.rcw.brightness / 100 // Map brightness (0-100) to alpha (0-1)
    ctx.fillStyle = `rgba(0, 0, 0, ${alpha})` // Black overlay with calculated alpha
    ctx.beginPath()
    ctx.arc(width / 2, height / 2, adjustedRadius, 0, 2 * Math.PI)
    ctx.fill()

    let radian = this.awardRotate
    ctx.restore()
    ctx.rotate(radian)
    ctx.closePath()
  }

  drawTurntable = async (ctx, width, height) => {
    const {
      wheelColors,
      fontStyle,
      weightOn,
      mysterySpin,
      // , wheelColorsTheme
    } = this.props

    if (ctx.canvas.width === 0 || ctx.canvas.height === 0) {
      return
    }
    ctx.translate(width / 2, height / 2) // use desired width and height because already wheelCanvasCtx.scale
    let radian
    let allTexts = []
    const MAX_LENGTH = !isMobileOnly ? 31 : 20
    if (!mysterySpin) {
      if (!this.props.isRIG) {
        for (let prize of this.prizes) {
          let str = prize
          if (str.length > MAX_LENGTH) {
            str = prize.substring(0, MAX_LENGTH - 1) + '…'
          }
          allTexts.push(str)
        }
        if (weightOn === false) {
          radian = this.awardRotate
          let maxFontSize = fontStyle.size
          for (let text of allTexts) {
            maxFontSize = this.fittingString(
              ctx,
              text,
              fontStyle.fontWeight,
              fontStyle.fontFamily,
              maxFontSize,
              radian,
            )
          }
        }
      } else {
        allTexts = this.prizes.slice(0)
        if (weightOn === false) {
          radian = this.awardRotate
        }
      }
    } else {
      allTexts = this.prizes.slice(0)
      if (weightOn === false) {
        radian = this.awardRotate
        this.fittingString(
          ctx,
          '?',
          fontStyle.fontWeight,
          fontStyle.fontFamily,
          fontStyle.size,
          radian,
        )
      }
    }

    for (let [i, prize] of allTexts.entries()) {
      if (weightOn === true) {
        radian = this.awardRotate[i]
      }
      ctx.save()
      let bgColor = wheelColors[0]
      // if (wheelColors.length === 4 && wheelColorsTheme !== 'Custom') {
      //   // default
      //   switch (i % wheelColors.length) {
      //     case 0:
      //       bgColor = wheelColors[0]
      //       break
      //     case 1:
      //       bgColor = wheelColors[2]
      //       break
      //     case 2:
      //       bgColor = wheelColors[1]
      //       break
      //     case 3:
      //       bgColor = wheelColors[3]
      //       break
      //   }
      // } else {
      bgColor = wheelColors[i % wheelColors.length]
      // }

      // continue
      ctx.beginPath()
      if (this.props.isBlankWheel) {
        // display blank pies when all inputs are removed/hidden from wheel
        if (!this.props.isRIG && !this.props.isRCW) {
          this.drawBackColor(ctx, radian, bgColor)
          ctx.restore()
          ctx.rotate(radian)
        } else {
          ctx.restore() //have to restore because previous function turn the context to half
          this.drawBackColor(ctx, radian, '#FFFFFF')
          this.drawBorder(ctx, radian, 1)
          ctx.restore()
          ctx.rotate(radian)
        }
        continue
      }
      if (mysterySpin && !this.emptyInput) {
        this.drawBackColor(ctx, radian, bgColor)
        this.drawText(ctx, radian, bgColor, '?', fontStyle, false, weightOn)
        ctx.restore()
        ctx.rotate(radian)
        continue
      }
      if (this.props.isPW) {
        const inputImage =
          this.inputImages !== undefined ? this.inputImages[i] : null
        const hasImage = inputImage !== null
        if (hasImage) {
          let image = await this.getWheelImage(inputImage)
          if (!image) {
            image = await this.getWheelImage(
              'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=',
            )
          }
          this.drawBgAndImage(ctx, radian, image, bgColor)
          ctx.restore() //have to restore because previous function turn the context to half
          ctx.save()
          bgColor = '#000000'
          // ctx.rotate(radian)
        } else {
          this.drawBackColor(ctx, radian, bgColor)
        }
        this.drawText(
          ctx,
          radian,
          bgColor,
          prize,
          fontStyle,
          hasImage,
          weightOn,
        )
        ctx.restore()
        ctx.rotate(radian)
      } else if (this.props.isRIG) {
        if (prize !== 'YES' && prize !== 'NO') {
          let image = await this.getWheelImage(prize)
          if (!image) {
            image = await this.getWheelImage(
              'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=',
            )
          }
          this.drawBgAndImage(ctx, radian, image, bgColor)
        }
        ctx.restore() //have to restore because previous function turn the context to half
        this.drawBorder(ctx, radian, 1)
        // this.drawCircle(ctx, 2.5) //removed this too thick
        ctx.restore()
        ctx.rotate(radian)
      } else {
        this.drawBackColor(ctx, radian, bgColor)
        this.drawText(ctx, radian, bgColor, prize, fontStyle, false, weightOn)
        ctx.restore()
        ctx.rotate(radian)
      }
    }
    if (!this.props.isRIG) {
      const prizeLength = this.prizes.length
      if (prizeLength % wheelColors.length === 1) {
        this.drawSameColorSeparator(ctx)
      }
    }
    ctx.closePath()
  }

  drawSameColorSeparator(ctx) {
    ctx.beginPath()
    ctx.lineWidth = 0.5
    ctx.strokeStyle = '#fff'
    const x = this.R
    const y = 0
    ctx.moveTo(0, 0)
    ctx.lineTo(x, y)
    ctx.stroke()
  }

  getWheelImage = async imageData => {
    if (imageData) {
      if (!this.props.wheelImages[imageData]) {
        return new Promise((resolve, reject) => {
          const image = new Image()
          // const self = this;
          image.onload = () => {
            // this.drawBgAndImage(image)
            this.props.setWheelImages({
              ...this.props.wheelImages,
              [imageData]: image,
            })
            resolve(image)
          }
          image.onerror = () => {
            resolve(false)
          }
          image.setAttribute('crossOrigin', 'anonymous')
          image.src = imageData

          // this.wheelImages[imageData] = image
        })
      } else {
        return this.props.wheelImages[imageData]
      }
    }
  }

  drawBgAndImage(ctx, rad, image, bgColor) {
    let imgBgColor = ImageUtil.getTopLeftColor(image)
    if (ImageUtil.isTransparent(imgBgColor) || this.props.isPW) {
      imgBgColor = bgColor
    }

    this.drawBackColor(ctx, rad, imgBgColor)
    ctx.translate(0, 0)
    const halfRad = rad / 2
    ctx.rotate(halfRad + Math.PI) //added Math.PI to invert the image.
    this.drawImage(ctx, halfRad, this.R, 40, image)
  }

  drawImage(ctx, halfRad, radius, buttonRadius, image) {
    let p = this.getImagePos(
      halfRad,
      radius,
      buttonRadius,
      image.height / image.width,
    )
    ctx.drawImage(image, p.x, p.y, p.w, p.h)
  }

  getImagePos(halfRad, radius, buttonRadius, imageRatio) {
    let w, h
    for (w = radius; w > 0; w--) {
      h = w * imageRatio
      if (ImageUtil.boxFits(halfRad, radius, buttonRadius, w, h)) {
        break
      }
    }
    return {
      x: -Math.max(
        (h * Math.cos(halfRad)) / (2 * Math.sin(halfRad)),
        buttonRadius,
      ), //added - to invert the image.
      y: h / 2, //removed - to invert the image.
      w: -w, //added - to invert the image.
      h: -h, //added - to invert the image.
    }
  }

  drawBorder(ctx, rad, width, color = '#aaa') {
    ctx.lineWidth = width
    ctx.strokeStyle = color
    ctx.moveTo(0, 0)
    ctx.arc(0, 0, this.R, 0, rad, false) // this.R-1 better, thicker line
    ctx.lineTo(0, 0)
    ctx.stroke()
  }

  drawCircle(ctx, width) {
    ctx.lineWidth = width
    ctx.strokeStyle = '#5a5a5a'
    ctx.arc(0, 0, this.R, 0, 2 * Math.PI)
    ctx.stroke()
  }

  drawBackColor(ctx, rad, bgColor) {
    ctx.fillStyle = bgColor
    ctx.moveTo(0, 0)
    ctx.arc(0, 0, this.R, 0, rad)
    ctx.lineTo(0, 0)
    ctx.fill()
  }

  getTextColor(bgColor) {
    const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor
    const r = parseInt(color.substring(0, 2), 16) // hexToR
    const g = parseInt(color.substring(2, 4), 16) // hexToG
    const b = parseInt(color.substring(4, 6), 16) // hexToB
    return r * 0.299 + g * 0.587 + b * 0.114 > 150 ? '#000000' : '#FFFFFF'
  }

  drawText(
    ctx,
    radian,
    bgColor,
    text,
    fontStyle,
    hasImage = false,
    diffFont = true,
  ) {
    const { fontWeight, fontFamily, size } = fontStyle
    ctx.fillStyle = this.getTextColor(bgColor)
    if (hasImage) {
      // ctx.strokeStyle = '#000000'
      // ctx.lineWidth = 1
      ctx.shadowColor = '#000000'
      ctx.shadowBlur = 4
    }

    ctx.lineJoin = 'round'
    ctx.textBaseline = 'middle'
    ctx.rotate(radian / 2 + Math.PI)
    // let maxWidth = this.TEXT_R - 50
    let maxSize = size
    // if (this.prizes.length >= 100) {
    //   preMaxSize = size - 13
    //   maxWidth = this.TEXT_R - 95
    // } else if (this.prizes.length > 30) {
    //   preMaxSize = size - 5
    //   maxWidth = this.TEXT_R - 75
    // } else if (this.prizes.length > 20) {
    //   preMaxSize = size - 2
    //   maxWidth = this.TEXT_R - 55
    // }
    // let height
    // if (this.props.weightOn === false) {
    //   height = this.heightPie
    // } else {
    //   height = this.heightPie[index]
    // }

    // let str = text
    // if (str.length > MAX_LENGTH) {
    //   str = text.substring(0, MAX_LENGTH - 1) + '…'
    // }
    if (diffFont) {
      this.fittingString(ctx, text, fontWeight, fontFamily, maxSize, radian)
    }

    ctx.fillText(text, -this.TEXT_R, 0)
  }

  fittingString = (ctx, str, fontWeight, fontFamily, preMaxSize, radian) => {
    let width = 0
    let maxSize = preMaxSize
    let minSize = 3
    // let maxWidth = preMaxWidth
    const HUB_RADIUS = 50 // 40 circle + 15 arrow

    ctx.font = `${fontWeight} ${maxSize + 'px'} ${fontFamily}`
    width = ctx.measureText(str).width
    if (
      ImageUtil.boxFits(radian / 2, this.TEXT_R, HUB_RADIUS, width, maxSize)
    ) {
      // console.log('max-size:', maxSize)
      return maxSize
    }
    if (this.prizes.length > 450) {
      ctx.font = `${fontWeight} ${minSize + 'px'} ${fontFamily}` // test min size can fit or not, if fit then run bisect to find suitable font size
      width = ctx.measureText(str).width
      if (
        !ImageUtil.boxFits(radian / 2, this.TEXT_R, HUB_RADIUS, width, minSize)
      ) {
        ctx.font = `${fontWeight} ${minSize - 1 + 'px'} ${fontFamily}`
        // console.log('here', minSize - 1)
        return minSize - 1
      }
    }

    while (true) {
      //bisection method  => faster method
      const newSize = Math.round((minSize + maxSize) / 2)
      ctx.font = `${fontWeight} ${newSize + 'px'} ${fontFamily}`
      width = ctx.measureText(str).width
      let minSizeSelected = true
      if (
        ImageUtil.boxFits(radian / 2, this.TEXT_R, HUB_RADIUS, width, newSize)
      ) {
        minSize = newSize
      } else {
        maxSize = newSize
        minSizeSelected = false
      }
      if (Math.abs(maxSize - minSize) < 2) {
        if (!minSizeSelected) {
          ctx.font = `${fontWeight} ${minSize + 'px'} ${fontFamily}` // always take the min size, ensure fit into box
        }
        // console.log('font-size:', minSize, maxSize)
        break
      }
    }
    return minSize
  }

  runFrame = ms => {
    ////////////////////////////////////////////////////
    //this part make sure it paints every 60fps
    const timeStep = 1000 / 60 //frame rate 60fps
    let msDiff
    let round = 1
    if (ms) {
      msDiff = ms - this.lastFrameMs
      // console.log(msDiff)
      if (msDiff < 0) {
        this.animateId = requestAnimationFrame(this.runFrame)
        return
      }
      this.timeframeDelta += msDiff
      if (this.timeframeDelta < timeStep) {
        // this is for frame run faster than 60 fps
        this.lastFrameMs = ms // added for fixed frame rate 60fps
        this.animateId = requestAnimationFrame(this.runFrame)
        return
      }
      // this.timeframeDelta -= msDiff  // variable fps
      round = Math.floor(this.timeframeDelta / timeStep) // round maybe more than 1 for frame run slower than 60fps
      this.timeframeDelta = this.timeframeDelta % timeStep // added for fixed frame rate 60fps
      this.lastFrameMs = ms
    } else {
      this.lastFrameMs = window.performance.now()
      // msDiff = timeStep
      // this.timeframeDelta += msDiff
    }
    ////////////////////////////////////////////////////
    if (
      this.props.initialSpinning &&
      this.props.hasSpinOnce === false &&
      !this.state.isRotate
    ) {
      if (!this.props.isEditing) {
        // for (let i = 0; i < round; i++) {  // this only always run one time even missed, to reduce initial lagging effect
        // need to catch more than 2 rounds if frame is slower than 60fps
        this.initialRotation()
        this.drawPickerWheel()
        // }
      } else if (
        this.props.isEditing &&
        this.props.angle !== this.startRotate
      ) {
        this.props.setStartRotate(this.startRotate)
      } //save stopping angle
      this.animateId = requestAnimationFrame(this.runFrame)
    } else if (this.state.isRotate) {
      for (let i = 0; i < round; i++) {
        // need to catch more than 2 rounds if frame is slower than 60fps
        this.rotateTurntable()
        this.drawPickerWheel()
        if (
          this.props.isRCW &&
          this.props.rcw.inputMethod === 'ColorWheel' &&
          this.props.rcw.pointer === 'Random'
        ) {
          this.drawPickerWheelDot()
        }
        if (this.rotateTime >= this.rotateAllTime) break // when round is more than 1
      }
      this.animateId = requestAnimationFrame(this.runFrame)
    }
  }

  initialRotation = () => {
    this.startRotate += this.initialRotationSpeed
    // this.totalRotate += this.initialRotationSpeed
    if (this.startRotate > Math.PI * 2) {
      this.startRotate -= Math.PI * 2
      // this.spinRound += 1
    }
  }

  rotateTurntable = () => {
    const isRandomDotColorWheel =
      this.props.isRCW &&
      this.props.rcw.inputMethod === 'ColorWheel' &&
      this.props.rcw.pointer === 'Random'

    ////////////////////////////////////////////////////
    //count timing
    if (
      this.props.manualStop &&
      this.rotateTime >= (this.accelerateTime * 7) / 10 && //dont go to max too fast
      this.state.alwaysSpinning === true
    ) {
      if (this.autoStopTimer === null) {
        this.autoStopTimer = setTimeout(() => {
          this.setState({ alwaysSpinning: false })
        }, 60000)
      }
    } else {
      // this.rotateTime += msDiff // variable fps
      this.rotateTime += 1 //every count equal to 1000/60 sec (60fps)
    }
    ////////////////////////////////////////////////////

    ////////////////////////////////////////////////////
    //this part make the wheel accelerate and decelerate
    if (this.rotateTime <= this.accelerateTime) {
      //acceleration to random position
      if (
        this.props.manualStop &&
        this.rotateTime >= (this.accelerateTime * 7) / 10 //dont go to max too fast
        // this.state.alwaysSpinning === true // comment this prevent speed to increase after reaching threshold
      ) {
        //do nothing, , at constant speed
      } else {
        const newPositionRadian = accelerateCubic(
          this.rotateTime,
          0,
          this.randomRadian,
          this.accelerateTime,
        )
        this.rotateSpeedRad =
          newPositionRadian -
          this.oldPositionRadian +
          this.initialRotationSpeed * 2 // this added for initial spinning, so that when click start it starts from the initialrotationspeed x 2
        this.oldPositionRadian = newPositionRadian

        if (isRandomDotColorWheel) {
          const newPositionDot = accelerateCubic(
            this.rotateTime,
            0,
            this.randomDotPosition,
            this.accelerateTime,
          )
          this.moveSpeedDot = newPositionDot - this.oldPositionDot
          this.oldPositionDot = newPositionDot
        }
      }

      if (this.rotateTime === this.accelerateTime) {
        // at top speed, calculate deceleration const
        this.decelerateConst = Math.exp(
          Math.log(this.stopSpeed / this.rotateSpeedRad) / this.decelerateTime,
        )
        // console.log(
        //   this.randomRadian,
        //   this.rotateSpeedRad,
        //   //this.totalRotate,
        //   this.decelerateTime,
        //   this.decelerateConst,
        //   this.totalRotate + this.rotateSpeedRad,
        //   this.totalRotate + this.rotateSpeedRad - this.randomRadian,
        // )
      }
      // } else if (
      //   this.rotateTime <= this.accelerateTime + this.topSpeedTime &&
      //   !this.props.manualStop
      // ) {
      //do nothing, at top speed
    } else {
      //during deceleration
      this.rotateSpeedRad = this.rotateSpeedRad * this.decelerateConst
      if (isRandomDotColorWheel) {
        this.moveSpeedDot = this.moveSpeedDot * this.decelerateConst
      }
    }

    // if (this.rotateSpeedRad < 0.005 && this.rotateTime < this.accelerateTime) {
    //   this.rotateSpeedRad = 0.005
    // }
    this.startRotate += this.rotateSpeedRad
    // this.totalRotate += this.rotateSpeedRad
    if (this.startRotate > Math.PI * 2) {
      this.startRotate -= Math.PI * 2
      // this.spinRound += 1
    }

    if (isRandomDotColorWheel) {
      this.startMoveDot += this.moveSpeedDot
      if (this.startMoveDot > 100) {
        this.startMoveDot -= 100
      }
    }
    ////////////////////////////////////////////////////

    // console.log(
    //   'spinround',
    //   this.startRotate,
    //   this.rotateSpeedRad,
    //   this.decelerateConst,
    //   this.rotateTime,
    //   this.accelerateTime,
    //   this.spinRound,
    //   this.totalRotate,
    // )

    // console.log(
    //   'movedot',
    //   this.startMoveDot,
    //   this.moveSpeedDot,
    //   this.decelerateConst,
    //   this.rotateTime,
    //   this.accelerateTime,
    //   this.spinRound,
    //   this.totalRotate,
    // )

    ////////////////////////////////////////////////////
    //this part check if the it passed one pie and play sound
    let pos = this.getCurrentPosition()
    const {
      wheelColors,
      // , wheelColorsTheme
    } = this.props
    let pieColor = wheelColors[0]
    // if (wheelColors.length === 4 && wheelColorsTheme !== 'Custom') {
    //   // default
    //   switch (pos % wheelColors.length) {
    //     case 0:
    //       pieColor = wheelColors[0]
    //       break
    //     case 1:
    //       pieColor = wheelColors[2]
    //       break
    //     case 2:
    //       pieColor = wheelColors[1]
    //       break
    //     case 3:
    //       pieColor = wheelColors[3]
    //       break
    //   }
    // } else {
    pieColor = wheelColors[pos % wheelColors.length]
    // }
    this.setState({ pieColor })
    if (
      this.props.music.soundOn &&
      (this.props.isRCW && this.props.rcw.inputMethod === 'ColorWheel'
        ? Math.abs(pos - this.pastPosition) > 15
        : pos != this.pastPosition) && // since total 1530 pies for color wheel, so make it become totally 100 pies, then will be every 15 tick one time
      Audio.isSpinningSoundRepeat
    ) {
      this.pastPosition = pos //current index
      Audio.playSound('spinning') //don't need loop
    }
    ////////////////////////////////////////////////////

    ////////////////////////////////////////////////////
    //check if timing achieve
    if (this.rotateTime >= this.rotateAllTime) {
      this.setState({ isRotate: false })
      this.noticePrize()
      this.initialRotationSpeed = 0
    }
    ////////////////////////////////////////////////////
  }

  onStartRotate = (soundStarting = true) => {
    const {
      speed,
      duration,
      onStart,
      manualStop,
      isRNG,
      isEmb,
      initialSpinning,
      hasSpinOnce,
    } = this.props
    if (this.state.isRotate) return
    if (onStart && !onStart()) return
    const isInitialSpinning = initialSpinning && hasSpinOnce === false //store the isinitialspinning memory first for later condition

    // if (this.props.music.soundOn && this.props.music.starting) {
    if (this.props.music.soundOn) {
      Audio.unmuteAllSounds()
      Audio.stopSound('ending') //ensure the ending sound stop before starting next spin
      if (soundStarting) {
        //always true for all wheel except the rng auto spin merge
        // this.audioStart.play()
        Audio.playSound('starting')
        if (!Audio.isSpinningSoundRepeat) {
          Audio.playSound('spinning', true) //need loop
        }
      }
    }
    if (isRNG) {
      const { typeOption, resultsArray } = this.props.rng
      if (typeOption > 0) {
        let firstSpin = true
        for (let i = 0; i < resultsArray.length; i++) {
          if (resultsArray[i] !== null) {
            firstSpin = false
          }
        }
        if (firstSpin) this.props.increaseSpinQuantity()
      } else {
        this.props.increaseSpinQuantity()
      }
    } else {
      this.props.increaseSpinQuantity()
    }

    this.setState({ isRotate: true }, () => {
      this.timeframeDelta = 0
      this.rotateTime = 0
      // this.spinRound = 0
      // this.totalRotate = 0
      this.oldPositionRadian = 0
      this.rotateSpeedRad = 0
      this.stopSpeed = 0.00018
      const mathRandom = seedrandom()

      // if (!manualStop) {
      this.rotateAllTime = duration * 60 //60fps, mean run 60 times equal 1 sec
      this.accelerateTime = Math.min(60, this.rotateAllTime / 4)
      // this.topSpeedTime = duration > 1 ? Math.min(60, this.rotateAllTime / 20) : 0 // duration 1 no top speed
      this.decelerateTime = this.rotateAllTime - this.accelerateTime
      this.randomRadian =
        (speed / 2.0) * 2 * Math.PI + mathRandom() * 2 * Math.PI // more speed more rotation then add 1 rotation for randomness. This is for accelerating to this point.
      // console.log(
      //   'speed',
      //   this.randomRadian,
      //   this.accelerateTime,
      //   this.decelerateTime,
      // )

      if (
        this.props.isRCW &&
        this.props.rcw.inputMethod === 'ColorWheel' &&
        this.props.rcw.pointer === 'Random'
      ) {
        this.oldPositionDot = 0
        this.moveSpeedDot = 0
        this.randomDotPosition = (speed / 2.0) * 100 + mathRandom() * 100
      }

      if (manualStop) {
        this.autoStopTimer = null
        this.decelerateTime = this.rotateAllTime - this.accelerateTime //no top speed time
        this.setState({ alwaysSpinning: true })
      }

      if (!isInitialSpinning) {
        this.runFrame()
      }
    })
  }

  stopRotate = () => {
    this.setState({ alwaysSpinning: false })
    clearTimeout(this.autoStopTimer)
  }
  initTurntable = () => {
    const {
      width,
      height,
      prizes,
      images,
      tempPrizes,
      angle,
      weightOn,
      weights,
    } = this.props

    let finalWeights = []
    if (prizes.length === 0) {
      this.emptyInput = true
      if (!this.props.isRIG) {
        this.prizes = tempPrizes.slice(0)
      } else {
        this.prizes = imagePlaceholder.slice(0)
      }
      finalWeights = [1, 1, 1, 1, 1, 1, 1, 1]
    } else {
      this.emptyInput = false
      this.prizes = prizes
      finalWeights = weights
    }

    if (images !== null && images.length > 0) {
      this.inputImages = images
    }

    let totalWeight = this.prizes.length
    if (weightOn) {
      totalWeight = finalWeights.reduce((a, b) => a + b, 0)
    }
    this.startRotate = angle
    this.rotateTime = 0
    this.rotateAllTime = 0
    this.randomRadian = 0
    this.oldPositionRadian = 0
    this.initialRotationSpeed = 0

    this.dpiRatio = window.devicePixelRatio
    // if (this.dpiRatio - 1 > 0) {
    //   this.dpiRatio = 1 + (this.dpiRatio - 0) / 2.0
    // }
    // this.dpiRatio = 2
    this.rotatingCanvasCtx = this.rotatingCanvas.getContext('2d')
    this.rotatingCanvas.width = width * this.dpiRatio
    this.rotatingCanvas.height = height * this.dpiRatio
    this.rotatingCanvas.style.width = width + 'px' //actual width of canvas, scale down
    this.rotatingCanvas.style.height = height + 'px'
    this.centerX = this.rotatingCanvas.width / 2 // use scaled canvas width
    this.centerY = this.rotatingCanvas.height / 2 // use scaled canvas height

    if (weightOn === false) {
      this.awardRotate = (Math.PI * 2) / this.prizes.length // each portion angle
    } else {
      this.awardRotate = []
      for (let i = 0; i < this.prizes.length; i++) {
        this.awardRotate[i] = (finalWeights[i] * (Math.PI * 2)) / totalWeight
      }
    }

    this.wheelCanvas = null // another wheel image canvas
    this.R = width / 2 - 10 // center minus 10 radius of canvas, for wheelCanvas
    const offSet = isMobileOnly ? 10 : 12
    this.TEXT_R = this.R - offSet //R - 25 starting distance to write text, , for wheelCanvas
    this.pastPosition = this.getCurrentPosition()

    this.drawPickerWheel()

    if (this.props.isRCW && this.props.rcw.inputMethod === 'ColorWheel') {
      this.randomDotPosition = 0
      this.oldPositionDot = 0

      const distanceFactor = this.props.rcw.pointerPosition
      this.startMoveDot =
        this.calculateStartMoveDotFromDistanceFactor(distanceFactor)
      const dotPosition =
        this.calculateDotPositionFromDistanceFactor(distanceFactor)
      this.setState({
        dotPosition: dotPosition,
        distanceFactor: distanceFactor,
      })
    }
  }

  refresh() {
    this.wheelCanvas = null
  }

  getTurntable = () => {
    if (this.props.getTurntable) {
      this.props.getTurntable({
        start: this.onStartRotate,
        stop: this.stopRotate,
      })
    }
  }

  onKeyDown = event => {
    if (this.props.resultModalAppear) return
    if (event.key === 'Enter' && event.ctrlKey) {
      event.preventDefault()
      if (
        !this.state.isRotate ||
        !this.props.manualStop ||
        !this.state.alwaysSpinning
      ) {
        // this.setState({ buttonDown: false })
        this.onStartRotate()
      } else {
        // this.setState({ buttonDown: false })
        this.stopRotate()
      }
    }
    // document.addEventListener('keydown', event => {
    //   if (event.key == 'Enter' && event.ctrlKey) {
    //     this.setState({ buttonDown: true })
    //   }
    // })
  }

  componentDidMount() {
    this.setState({ finishRender: false })
    this.compatibilityFrame()
    this.initTurntable()
    this.getTurntable()
    this.setState({ finishRender: true })
    if (this.props.initialSpinning && this.props.hasSpinOnce === false) {
      this.initialRotationSpeed = 0.0015
      this.timeframeDelta = 0
      this.runFrame()
    }
    if (!isMobile && !this.props.isEmb) {
      document.addEventListener('keydown', this.onKeyDown)
    }
    const { starting, spinning, celebrating, customOn } = this.props.music
    let tempCelebrating = celebrating
    if (this.props.isEmb) {
      tempCelebrating = 'short-announcement-sound'
    }
    Audio.preloadSound(starting, 'starting')

    if (!spinning.includes('http')) {
      Audio.preloadSound(spinning, 'spinning')
    } else {
      if (customOn) {
        Audio.preloadSound(replaceCDN(spinning), 'spinning')
      } else {
        Audio.preloadSound(Audio.spinningSounds[1].src, 'spinning')
      }
    }

    if (!tempCelebrating.includes('http')) {
      Audio.preloadSound(tempCelebrating, 'ending')
    } else {
      if (customOn) {
        Audio.preloadSound(replaceCDN(tempCelebrating), 'ending')
      } else {
        Audio.preloadSound(Audio.endingSounds[1].src, 'ending')
      }
    }

    if (this.props.isRNG) {
      Audio.preloadShortAnnouce()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { starting, spinning, celebrating, customOn } = this.props.music
    if (
      prevProps.music.starting !== starting ||
      prevProps.music.spinning !== spinning ||
      prevProps.music.celebrating !== celebrating ||
      prevProps.music.customOn !== customOn
    ) {
      Audio.preloadSound(starting, 'starting')

      if (!spinning.includes('http')) {
        Audio.preloadSound(spinning, 'spinning')
      } else {
        if (customOn) {
          Audio.preloadSound(replaceCDN(spinning), 'spinning')
        } else {
          Audio.preloadSound(Audio.spinningSounds[1].src, 'spinning')
        }
      }

      if (!celebrating.includes('http')) {
        //emb will not update
        Audio.preloadSound(celebrating, 'ending')
      } else {
        if (customOn) {
          Audio.preloadSound(replaceCDN(celebrating), 'ending')
        } else {
          Audio.preloadSound(Audio.endingSounds[1].src, 'ending')
        }
      }
    }

    // When changing the spinning pointer from random to manual, reset the dot position to the user-defined value.
    if (
      this.props.isRCW &&
      this.props.rcw.inputMethod === 'ColorWheel' &&
      prevState.spinningPointer !== this.props.rcw.pointer &&
      this.props.rcw.pointer === 'Manual'
    ) {
      const distanceFactor = this.props.rcw.pointerPosition
      if (this.props.isRCW && prevState.distanceFactor !== distanceFactor) {
        const dotPosition =
          this.calculateDotPositionFromDistanceFactor(distanceFactor)
        this.setState({
          dotPosition: dotPosition,
          distanceFactor: distanceFactor,
        })
      }
    }
  }

  destroyContext() {
    window.cancelAnimationFrame(this.animateId)
    if (!isMobile && !this.props.isEmb) {
      document.removeEventListener('keydown', this.onKeyDown)
    }
    delete this.rotatingCanvas
    delete this.rotatingCanvasCtx
  }
  compatibilityFrame() {
    window.requestAnimFrame = (() => {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        (callback => window.setTimeout(callback, 1000 / 60))
      )
    })()
    window.cancelAnimationFrame =
      window.cancelAnimationFrame || window.mozCancelAnimationFrame
  }
  componentWillUnmount() {
    this.destroyContext()
  }
}

export default withLocation(connect(mapState, actions)(ReactTurntable))
